var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-phone",
    "data-name": "Icon akar-phone",
    d: "M9.964,6.451,7.21,3.272a.866.866,0,0,0-1.268,0L3.676,5.546A2.189,2.189,0,0,0,3.2,8.027,23.78,23.78,0,0,0,14.24,19.083a2.184,2.184,0,0,0,2.478-.478L19,16.315a.869.869,0,0,0,0-1.273L15.815,12.3a.877.877,0,0,0-1.187.086L13.517,13.5a.376.376,0,0,1-.45.072A11.852,11.852,0,0,1,8.7,9.2a.377.377,0,0,1,.072-.451L9.882,7.643a.881.881,0,0,0,.082-1.193Z",
    transform: "translate(-16.141 27.859)",
    fill: "#00b26b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCard);
export default __webpack_public_path__ + "static/media/MobileCard.b059c780052fffee09ed83e5203f3e2e.svg";
export { ForwardRef as ReactComponent };